
import React, { Component } from 'react';
import 'antd/dist/antd.css';
import '../css/lista_titular_comites.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserEdit, faUserTimes, faUserTie, faEnvelopeSquare, faFileExcel, faListOl } from '@fortawesome/free-solid-svg-icons';
import '../css/lista_representantes.css';
import { Row, Col} from 'antd';
import {Link, Redirect} from 'react-router-dom';
import { Table, Divider} from 'antd';
import { Modal, message, Button, Icon, Drawer, Form, Input, Select } from 'antd';
import Highlighter from 'react-highlight-words';

import  AdminNavBar  from './AdminNavBar';
import ExportExcel from './ExportExcel';

import {logout, admin_titulares, admin_actualizar_titular, admin_titular_borrar, 
  isLoginAdmin, titular_comite_representante, actualizar_campos_representante, 
  historial_representante} from '../utils/JWTAuth';

const { Option } = Select;

let lista_admin_titulares, isAdmin;
let comite_id, state, borrar_titular = 0;
let nuevo_representante_id, url, codigo_id;
let correos, registros;

const sleep = (milliseconds) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

const success = (messages) => {
  message.success(messages);
};

const error = (messages) => {
  message.error(messages);
};

const warning = (messages) => {
  message.warning(messages);
};

const borrarTitular = (e)=>{
    borrar_titular = e.currentTarget.getAttribute('data-id-titular');
    comite_id = e.currentTarget.getAttribute('data-id-comite');

  state.setState({
    visibleBorrar: true
  });

}

const borrarAdminRepresentantes = (e) => {

  borrar_titular = e.currentTarget.getAttribute('data-id-titular');
  comite_id = e.currentTarget.getAttribute('data-id-comite');

  state.setState({
    visibleBorrarAdmin: true
  });

}

const cambiarAdmin = (e) => {
  nuevo_representante_id = e.currentTarget.getAttribute('data-id-representante');
  comite_id = e.currentTarget.getAttribute('data-id-comite');
  codigo_id = e.currentTarget.getAttribute('data-id-codigo');

  state.setState({
    visibleAdmin: true
  });

}



const pagination = {
  pageSizeOptions: ['10', '50','100'],
  showSizeChanger: true
};

  function onChange(pagination, filters, sorter, extra) {
    
  }

class ListaTitulares extends Component {

  stateTable = {
    searchText: '',
    searchedColumn: '',
  };

  stateSelected = {
    selectedRowKeys: [], // Check here to configure the default column
  };

  

  constructor(){
    super();

    state = this;
    
    this.state = {
      comite: 0,
      admin_titulares: [],
      visibleBorrar: false,
      visibleBorrarAdmin: false,
      visibleAdmin: false,
      redirectAdmin: false,
      registros_excel: [],
      isConsultor: false,
      visibleHistorial: false,
      datos_historial: [],
      visibleEditar: false,
      form_id: '',
      form_nombre: '',
      form_cargo: '',
      form_telefono: '',
      form_profesion: '',
    } 

    isLoginAdmin().then(data => {
      console.log('el admin: ',data);
      switch(data.status){
        case 0:
            if(data.data.rol == 2){
              state.setState({
                isConsultor: true
              });
            }else{
              state.setState({
                isConsultor: false
              });
            }
          break;
      }
    });

    this.otra_profesion = React.createRef();
    this.pintarAdministradores();

  }

  showDrawerHistory = (e) => {
    let id_representante = e.target.parentElement.getAttribute('data-id-representante');

    console.log(id_representante);

    historial_representante(id_representante).then(data => {
      switch(data.status){
        case 0:
          state.setState({datos_historial: data.data, visibleHistorial:true});
          break;
        case 5:
          error('Error de Conexión');
        break;
      }
    });
  }

  showDrawer = (e) => {

    console.log(e.target.parentElement.getAttribute('data-id-representante'));
    let id_form = e.target.parentElement.getAttribute('data-id-representante');
    titular_comite_representante(0,e.target.parentElement.getAttribute('data-id-representante')).then(data => {
      console.log(data);
      switch(data.status){
          case 0:

            this.setState({
              visibleEditar: true,
              form_id: id_form,
              form_nombre: data.data.nombre,
              form_cargo: data.data.cargo,
              form_telefono: data.data.telefono,
              form_profesion: data.data.profesion
            });
          break;
          case 5:
            error('Error de Conexión');
          break;
      }

    });

    
  };

  onClose = () => {
    this.setState({
      form_id: '',
      form_nombre: '',
      form_cargo: '',
      form_telefono: '',
      form_profesion: '',
      visibleHistorial:false,
      visibleEditar: false,
    });
  };

  pintarAdministradores(){

    admin_titulares().then(data => {

      switch(data.status){
        case 0:
          warning(data.data);
          window.location.href = "/";
          break;
          case 1:
            state.setState({
              admin_titulares: data.data
            });
            break;
        case 5:
          error('Error de Conexión');
          break;
      }

  
    });

  }

  handleChange(value) {
    console.log(`selected ${value}`);
    if(value == 'otro'){
      state.setState({mostrar_otro_cargo: true});
    }else{
      state.setState({mostrar_otro_cargo: false});
    }
  }

  handleConfirmBlur = e => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        values['id'] = state.state.form_id;
        console.log('Received values of form: ', values, );

        actualizar_campos_representante(values).then(data => {
          switch(data.status){
            case 0:
              success('Cambios guardados');
              state.onClose();
              state.pintarAdministradores();
              break;
            case 5:
              error('Error de Conexión');
              break;
          }
        });

      }
    });
  };

    componentDidMount() {
      const { match: { params } } = this.props;
    }

    handleOkBorrar = e => {


      let dataJson = {
        "representante_id" : borrar_titular,
        "comite_id" : comite_id
      }

     

      admin_titular_borrar(dataJson).then(data => {

        switch(data.status){
          case 5:
            error('Error de conexión');
            break;
          case 10:
            success('Usuario eliminado');
            state.pintarAdministradores();
            break;
        }

        this.setState({
          visibleBorrar: false,
          visibleBorrarAdmin: false,
        });

      });

      
    };

    handleOkAdmin = e => {
      

      let dataJson = {
        "representante_id":nuevo_representante_id,
        "comite_id": comite_id,
        "codigo_id": codigo_id
      }

      

       admin_actualizar_titular(dataJson).then(data => {
    
        switch(data.status){
          case 0:
            success('Administrador cambiado');
            state.pintarAdministradores();
            break;
          case 5:
            error('Error de Conexión');
            /*switch(state.props.match.params.num_comite){
              case 1: url = 'comite-nacional-seguridad-vial'; break;
              case 2: url = 'comite-prevencion-y-combate-al-delito'; break;
              case 3: url = 'comite-movilidad'; break;
              case 4: url = 'comite-ferroviario'; break;
              case 5: url = 'comite-juridico'; break;
              case 6: url = 'comite-tecnico'; break;
            }
        
            window.location.href = '/login/'+url+'/'+state.props.match.params.num_comite;*/
            break;
          
        }
    
        });
    
      

      this.setState({
        visibleAdmin: false,
      });
    };
  
    handleCancel = e => {
     
      
      this.setState({
        visibleAdmin: false,
        visibleBorrar: false,
        visibleBorrarAdmin: false
      });
    };

    getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={node => {
              this.searchInput = node;
            }}
            placeholder={`Buscar ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon="search"
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Buscar
          </Button>
          <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Limpiar
          </Button>
        </div>
      ),
      filterIcon: filtered => (
        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
      onFilter: (value, record) =>
        record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
      onFilterDropdownVisibleChange: visible => {
        if (visible) {
          setTimeout(() => this.searchInput.select());
        }
      },
      render: text =>
        this.state.searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[this.state.searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : (
          text
        ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      this.setState({
        searchText: selectedKeys[0],
        searchedColumn: dataIndex,
      });
    };
  
    handleReset = clearFilters => {
      clearFilters();
      this.setState({ searchText: '' });
    };
    
    onSelectChange = selectedRowKeys => {
      
      this.setState({ selectedRowKeys });

        // Usage!
        sleep(500).then(() => {
          // Do something after the sleep!
          state.exportarExcel();
      });

    };

    sleep (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    }
    
    

    enviarMail(){
      correos = document.getElementsByClassName('ant-table-row-selected');
      switch(correos.length){
        case 0:
          warning('No se ha seleccionado ningun usuario');
        break;
        default:
          let envio_correos = 'mailto:?bcc=';
          for(let i=0; i < correos.length; i++){

            if(i == 0){
              envio_correos+=correos[i].children[2].innerHTML;
            }else{
              envio_correos+=','+correos[i].children[2].innerHTML;
            }
          }
          
          window.location.href=envio_correos;
          break;
      }
      
    }

    exportarExcel(){
      
      registros = document.getElementsByClassName('ant-table-row-selected');
      switch(registros.length){
        case 0:
          warning('No se ha seleccionado ningun usuario');
        break;
        default:

          let registro_exc = [];

          for(let i=0; i < registros.length; i++){

            registro_exc.push(
              {
                nombre: registros[i].children[1].textContent, 
                correo: registros[i].children[2].textContent,
                telefono: registros[i].children[3].children[0].children[0].textContent,
                comite: registros[i].children[4].textContent,
                empresa: registros[i].children[5].textContent
              });
          }
          
          console.log(registro_exc);
          
          state.setState({registros_excel: registro_exc});
          
          break;
      }
      
    }

    render(){

      const { admin_titulares } = this.state;
        const rowSelection = {
          admin_titulares,
          onChange: this.onSelectChange,
        };

        const { getFieldDecorator } = this.props.form;
       

        const columns_historial = [
          {
            title: 'Acción',
            dataIndex: 'accion',
            key: 'accion',
          },
          {
            title: 'Representante',
            dataIndex: 'representante',
            key: 'representante',
          },
          {
            title: 'Correo',
            dataIndex: 'correo',
            key: 'correo',
          },
          {
            title: 'Fecha',
            dataIndex: 'created_at',
            key: 'created_at',
          },
        ];

        console.log('es consultor: ',state.state.isConsultor);

      const columns = [
        {
          title: 'Nombre',
          dataIndex: 'nombre',
          key: 'nombre',
          ...this.getColumnSearchProps('nombre'),
        },
        {
          title: 'E-mail',
          dataIndex: 'email',
          key: 'email',
          ...this.getColumnSearchProps('email'),
        },
        {
          title: 'Teléfono',
          dataIndex: 'telefono',
          key: 'telefono',
          render: text => <span><a href={`tel:${text}`}>{text}</a></span>,
        },
        {
          title: 'Comite',
          dataIndex: 'nombre_comite',
          key: 'nombre_comite',
          ...this.getColumnSearchProps('nombre_comite'),
        },
        {
          title: 'Empresa',
          dataIndex: 'empresa',
          key: 'empresa',
          ...this.getColumnSearchProps('empresa'),
        },
        {
          title: 'Representante',
          dataIndex: 'is_titular',
          key: 'is_titular',
          render: (text, record) => (
            <span>

              
              {
              record.codigo_id != 1 &&
              (
              text ?
                (
                <span><FontAwesomeIcon className="icon_user_admin" icon={ faUserTie } /> Titular </span>
                )
                :
                (state.state.isConsultor ?
                (<span><FontAwesomeIcon className="icon_user_no_admin" icon={ faUserTie } />Suplente </span>)
                
                :
                    (<span><FontAwesomeIcon
                    
                      onClick={ cambiarAdmin } 
                    
                      data-id-representante={record.id} data-id-comite={record.comite_id} data-id-codigo={record.codigo_id} className="icon_user_no_admin" icon={ faUserTie } />Suplente </span>)
                  )
                )
              }
            </span>
          ),
        },
        {
          title: 'Editar',
          dataIndex: 'id',
          key: 'representante_id',
          render: (text, record) => (
            <span>
              {!state.state.isConsultor && 

<FontAwesomeIcon data-id-representante={text} className="icon_user_edit" icon={faUserEdit} onClick={state.showDrawer} />
              }
              
              <Divider type="vertical" />

              {
              !state.state.isConsultor && 
              (
              
              record.is_titular ?
              (<FontAwesomeIcon onClick={borrarAdminRepresentantes} data-id-titular={text} data-id-comite={record.comite_id} className="icon_user_delete" icon={faUserTimes} />)
              :
              (<FontAwesomeIcon onClick={borrarTitular} data-id-titular={text} data-id-comite={record.comite_id} className="icon_user_delete" icon={faUserTimes} />)

              )
              }
              <span data-id-representante={text} onClick={state.showDrawerHistory}><FontAwesomeIcon className="icon_history" icon={faListOl} /></span>
              
            </span>
          ),
        },
      ];

      const formItemLayout = {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
      };
      const tailFormItemLayout = {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0,
          },
          sm: {
            span: 16,
            offset: 8,
          },
        },
      };
     
        return(
          <Row>
            <Col span={16} offset={6} style={{textAlign:'right'}}>
              <br /><br />
            <Button type="primary" shape="round" size="large"><FontAwesomeIcon onClick={this.enviarMail} className="icon_mail" icon={faEnvelopeSquare} /> </Button>
            <ExportExcel data={state.state.registros_excel} />
              <h3 style={{textAlign:'left'}}>Bienvenido Administrador a Comités</h3>
            </Col>
            <AdminNavBar />
            <Col span={16}>

              <Modal
                title="Eliminar Registro"
                visible={this.state.visibleBorrar}
                onOk={this.handleOkBorrar}
                onCancel={this.handleCancel}
              >
                <p>¿Esta seguro de eliminar este usuario?</p>
              </Modal>

              <Modal
                title="Eliminar Admnistrador"
                visible={this.state.visibleBorrarAdmin}
                onOk={this.handleOkBorrar}
                onCancel={this.handleCancel}
              >
                <p>Si eliminas al administrador de éste comité, todos los representantes del mismo también se eliminarán.
                  <br />
                  Puedes seleccionar a otra persona para que se vuelva el administrador del comité, antes de borrar al administrador actual.
                  <br /><br />¿Deseas continuar con la eliminación del administrador?</p>
              </Modal>

              <Modal
                title="Nuevo Admnistrador"
                visible={this.state.visibleAdmin}
                onOk={this.handleOkAdmin}
                onCancel={this.handleCancel}
              >
                <p>¿Esta seguro de cambiar al administrador?</p>
              </Modal>

              <Table rowSelection={rowSelection} columns={columns} dataSource={this.state.admin_titulares} onChange={onChange}/>

            </Col>

            <Drawer
            title="Historial"
            width={720}
            onClose={this.onClose}
            visible={this.state.visibleHistorial}
            bodyStyle={{ paddingBottom: 80 }}
            >
              <Table dataSource={state.state.datos_historial} columns={columns_historial} />
            </Drawer>

            <Drawer
          title="Actualizar Registro"
          width={720}
          onClose={this.onClose}
          visible={this.state.visibleEditar}
          bodyStyle={{ paddingBottom: 80 }}
        >
          <Form {...formItemLayout} onSubmit={this.handleSubmit}>
       
          {state.state.form_nombre != '' &&
        <Form.Item
          label={
            <span>
              Nombre:
            </span>
          }
        >
          {getFieldDecorator('nombre', {
            rules: [{ required: true, message: 'Por favor escribe un nombre', whitespace: true }],
            initialValue: this.state.form_nombre,
          })(<Input />)}
        </Form.Item>}

        {state.state.form_cargo != '' &&
        <Form.Item
          label={
            <span>
              Cargo:
            </span>
          }
        >
          {getFieldDecorator('cargo', {
            rules: [{ required: true, message: 'Por favor escribe un cargo', whitespace: true }],
            initialValue: this.state.form_cargo,
          })(<Input ref={this.form_cargo} />)}
        </Form.Item>}

        {state.state.form_telefono != '' &&
        <Form.Item
          label={
            <span>
              Teléfono:
            </span>
          }
        >
          {getFieldDecorator('telefono', {
            rules: [{ required: true, message: 'Por favor escribe un teléfono', whitespace: true }],
            initialValue: state.state.form_telefono,
          })(<Input  />)}
        </Form.Item>}

        {state.state.form_profesion != '' &&
        <Form.Item
          label={
            <span>
              Profesión:
            </span>
          }
        >
          {getFieldDecorator('profesion', {
            rules: [{ required: true, message: 'Por favor elige una profesión', whitespace: true }],
            initialValue: state.state.form_profesion,
          })(
            <Select ref={this.form_cargo} onChange={state.handleChange}>
              <Option value="Ing.">Ing.</Option>
              <Option value="Lic.">Lic.</Option>
              <Option value="Maestro">Maestro</Option>
              <Option value="Contador Público">Contador Público</Option>
              <Option value="otro">Otro</Option>
            </Select>
          )}
        </Form.Item>}

        {state.state.mostrar_otro_cargo &&

        <Form.Item
          label={
            <span>
              Otro:
            </span>
          }
        >
          {getFieldDecorator('otra_profesion', {
            rules: [{ required: true, message: 'Por favor escribe un teléfono', whitespace: true }],
            initialValue: state.state.form_profesion,
          })(<Input />)}
        </Form.Item>}
        
        
       
       
       
        <Form.Item {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">
            Actualizar
          </Button>
        </Form.Item>
      </Form>
        </Drawer>
          
           
           </Row>


            
        );
    }
}

const WrappedRegistrationForm = Form.create({ name: 'register' })(ListaTitulares);

export default WrappedRegistrationForm;
